import { QueryClient } from '@tanstack/react-query';

// One shared cache for the whole app.
//
// - Data is "fresh" for a minute: navigating back to a page renders instantly
//   from memory with no spinner and no request.
// - Stale data is still shown immediately while a fresh copy loads quietly in
//   the background (stale-while-revalidate).
// - Unused data is kept for ten minutes so returning to a page is cheap.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
      gcTime: 10 * 60 * 1000,
      // One retry for flaky requests, none when the session has expired.
      retry: (failureCount, error) => error?.response?.status !== 401 && failureCount < 1,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
    },
  },
});
